<img obgImageContent="general.warning" class="obg-m-login-yearly-review-icon" />

<h1 class="obg-m-login-yearly-review-heading">{{ "kyc-verify-popup.annual-review.title" | translate }}</h1>

<p class="obg-m-login-yearly-review-description">{{ welcomeMessageTranslation$ | async }}</p>

<p class="obg-m-login-yearly-review-notification">{{ "kyc-verify-popup.annual-review.description" | translate }}</p>

<button class="obg-m-login-yearly-review-button" mat-flat-button (click)="onReviewDetailsClick()">
	{{ "kyc-verify-popup.annual-review.cta" | translate }}
</button>
